function layoutSwitcher() {
  Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(link => {
    link.addEventListener('click', toggle);
    link.addEventListener('keydown', handleKeyDown);
  });
};
function handleKeyDown(event){
  if (event.keyCode === 13) {
    toggle(event);
  }
}
function toggle(event){
  Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(e => e.classList.remove('active'));
  event.currentTarget.classList.add('active');
  if(event.currentTarget.classList.contains('listv')){
    document.getElementById('ProductGridContainer').classList.add('product-list');
    document.getElementById('ProductGridContainer').classList.remove('product-grid');
  }else if(event.currentTarget.classList.contains('gridv')){
    document.getElementById('ProductGridContainer').classList.add('product-grid');
    document.getElementById('ProductGridContainer').classList.remove('product-list');
  }
}
document.addEventListener("shopify:section:load", layoutSwitcher);
layoutSwitcher();

// on scroll play video
window.addEventListener('load', videoScroll);
window.addEventListener('scroll', videoScroll);
function videoScroll() {
  if ( document.querySelectorAll('video[autoplay]').length > 0) {
    var windowHeight = window.innerHeight, videoEl = document.querySelectorAll('video[autoplay]');
    for (var i = 0; i < videoEl.length; i++) {
      var thisVideoEl = videoEl[i],
          videoHeight = thisVideoEl.clientHeight,
          videoClientRect = thisVideoEl.getBoundingClientRect().top;
      if ( videoClientRect <= ( (windowHeight) - (videoHeight*.5) ) && videoClientRect >= ( 0 - ( videoHeight*.5) ) ) {
        thisVideoEl.play();
      } else {
        thisVideoEl.pause();
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const countdowns = [];

  document.querySelectorAll('.countd_all').forEach(section => {
    const targetDate = new Date(section.dataset.date).getTime();

    countdowns.push({
      section,
      targetDate,
      days: section.querySelector('.wb_cdays'),
      hours: section.querySelector('.wb_chours'),
      minutes: section.querySelector('.wb_cminutes'),
      seconds: section.querySelector('.wb_cseconds')
    });
  });

  if (!countdowns.length) return;

  let timerStarted = false;
  let timerId = null;

  function updateCountdowns() {
    const now = Date.now();

    countdowns.forEach(item => {
      if (isNaN(item.targetDate)) return;

      const distance = item.targetDate - now;

      if (distance <= 0) {
        item.days && (item.days.textContent = '00');
        item.hours && (item.hours.textContent = '00');
        item.minutes && (item.minutes.textContent = '00');
        item.seconds && (item.seconds.textContent = '00');
        return;
      }

      item.days && (item.days.textContent = String(Math.floor(distance / 86400000)).padStart(2, '0'));
      item.hours && (item.hours.textContent = String(Math.floor((distance % 86400000) / 3600000)).padStart(2, '0'));
      item.minutes && (item.minutes.textContent = String(Math.floor((distance % 3600000) / 60000)).padStart(2, '0'));
      item.seconds && (item.seconds.textContent = String(Math.floor((distance % 60000) / 1000)).padStart(2, '0'));
    });

    timerId = setTimeout(updateCountdowns, 1000);
  }

  function startCountdown() {
    if (timerStarted) return;

    timerStarted = true;
    updateCountdowns();
  }

  // Observe all countdown sections instead of only the first one
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        observer.disconnect();

        if (window.requestIdleCallback) {
          requestIdleCallback(startCountdown);
        } else {
          setTimeout(startCountdown, 200);
        }
      }
    });
  }, {
    rootMargin: '200px'
  });

  countdowns.forEach(item => {
    observer.observe(item.section);
  });

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      clearTimeout(timerId);
      timerStarted = false;
    } else {
      const hasVisibleCountdown = countdowns.some(item => {
        const rect = item.section.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
      });

      if (hasVisibleCountdown) {
        startCountdown();
      }
    }
  });
});

(function () {
  const CTA_URL = '/pages/preventivatore-videosorveglianza';

  function ensureCctvCtaStyles() {
    if (document.getElementById('powernet-cctv-header-cta-styles')) return;

    const style = document.createElement('style');
    style.id = 'powernet-cctv-header-cta-styles';
    style.textContent = `
      .powernet-cctv-header-cta {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 7px;
        min-height: 42px;
        padding: 0 14px;
        margin-inline: 4px;
        border: 1px solid #ffd400;
        border-radius: 999px;
        background: #ffd400;
        color: #0b253f !important;
        text-decoration: none !important;
        font-weight: 800;
        line-height: 1;
        white-space: nowrap;
        box-shadow: 0 5px 14px rgba(11, 37, 63, .14);
        transition: transform .18s ease, box-shadow .18s ease, background .18s ease;
      }
      .powernet-cctv-header-cta:hover {
        transform: translateY(-1px);
        box-shadow: 0 7px 18px rgba(11, 37, 63, .22);
        background: #ffe033;
      }
      .powernet-cctv-header-cta:focus-visible {
        outline: 2px solid #0b253f;
        outline-offset: 2px;
      }
      .powernet-cctv-header-cta__icon {
        display: inline-flex;
        width: 18px;
        height: 18px;
        flex: 0 0 18px;
      }
      .powernet-cctv-header-cta__icon svg {
        width: 100%;
        height: 100%;
        fill: none;
        stroke: currentColor;
        stroke-width: 1.8;
        stroke-linecap: round;
        stroke-linejoin: round;
      }
      .powernet-cctv-header-cta__short { display: none; }
      @media (max-width: 1199px) {
        .powernet-cctv-header-cta { min-height: 40px; padding: 0 10px; gap: 5px; }
        .powernet-cctv-header-cta__label { display: none; }
        .powernet-cctv-header-cta__short { display: inline; }
      }
      @media (max-width: 575px) {
        .powernet-cctv-header-cta { min-height: 36px; padding: 0 8px; margin-inline: 2px; font-size: 11px; }
        .powernet-cctv-header-cta__icon { width: 16px; height: 16px; flex-basis: 16px; }
      }
    `;
    document.head.appendChild(style);
  }

  function mountCctvHeaderCta() {
    if (!document.body || !document.body.classList.contains('page-index')) return;

    ensureCctvCtaStyles();

    document.querySelectorAll('.header__icons').forEach((icons) => {
      if (icons.querySelector('.powernet-cctv-header-cta')) return;

      const login = icons.querySelector('user-popup');
      if (!login) return;

      const cta = document.createElement('a');
      cta.href = CTA_URL;
      cta.className = 'powernet-cctv-header-cta focus-inset';
      cta.setAttribute('aria-label', 'Apri il Preventivatore CCTV');
      cta.setAttribute('title', 'Preventivatore CCTV');
      cta.innerHTML = `
        <span class="powernet-cctv-header-cta__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" focusable="false">
            <path d="M4 7h3l1.5-2h7L17 7h3a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2Z"></path>
            <circle cx="12" cy="13" r="4"></circle>
          </svg>
        </span>
        <span class="powernet-cctv-header-cta__label">Preventivatore CCTV</span>
        <span class="powernet-cctv-header-cta__short">CCTV</span>
      `;

      login.parentNode.insertBefore(cta, login);
    });
  }

  document.addEventListener('DOMContentLoaded', mountCctvHeaderCta);
  document.addEventListener('shopify:section:load', mountCctvHeaderCta);
  if (document.readyState !== 'loading') mountCctvHeaderCta();
})();
